import { bindClickEventOnPseudoElement, closeEverything } from '@msc-b2c/shared-utils';

const closeSimpleBanner = (
  simpleBanner: HTMLElement,
  bannerIsInsideModal?: boolean,
  modalId?: string
) => {
  if (bannerIsInsideModal) {
    closeEverything(`#${modalId}`);
  } else {
    simpleBanner?.classList.add('hide');
  }
};

const autoCloseSimpleBanner = (
  simpleBanner: HTMLElement,
  bannerIsInsideModal?: boolean,
  modalId?: string,
  closingTime?: string | null
) => {
  if (bannerIsInsideModal) {
    const targetNode = simpleBanner?.parentElement?.parentElement;
    // Create an observer instance linked to the callback function
    const observer = new MutationObserver((mutationList) => {
      for (const mutation of mutationList) {
        if (mutation.attributeName === 'class') {
          const currentClasslist = targetNode?.classList;
          if (currentClasslist && !currentClasslist.contains('hide')) {
            setTimeout(() => {
              //this check is to verify that the modal is still open and has not been closed by the user while countdown is running
              if (!currentClasslist.contains('hide')) closeEverything(`#${modalId}`);
            }, Number(closingTime) * 1000);
          }
        }
      }
    });
    // Start observing the target node for configured mutations
    observer.observe(targetNode as Node, { attributes: true });
  } else {
    setTimeout(() => {
      simpleBanner?.classList.add('hide');
    }, Number(closingTime) * 1000);
  }
};

const simpleBanners: NodeListOf<HTMLElement> = document.querySelectorAll('.simplebanner');

//Close basic banner logic
const handlePseudoElementClick = (event: Event) => {
  const target = event.target as HTMLElement;
  const expandable = document.querySelector('.cmp-expandable-container');
  const darkHeader: HTMLElement | null = document.querySelector('.cmp-bottom-container-dark');
  const lightHeader: HTMLElement | null = document.querySelector('.cmp-bottom-container-light');

  let header: HTMLElement | null = null;
  let lists: NodeListOf<Element> | undefined;

  if (darkHeader) {
    header = darkHeader;
    lists = header.querySelectorAll('.cmp-list__item');
  } else if (lightHeader) {
    header = lightHeader;
    lists = header.querySelectorAll('.cmp-list__item');
  }

  const basicBanner = target.closest('.basicbanner');
  basicBanner?.classList.add('hide');
  expandable?.classList.add('hide');
  lists?.forEach((item) => {
    item.classList.remove('active');
  });
};

bindClickEventOnPseudoElement(
  '.basicbanner .basic-banner',
  true,
  'after',
  handlePseudoElementClick
);

simpleBanners.forEach((simpleBanner) => {
  const parentElement: HTMLElement | null | undefined = simpleBanner?.parentElement;
  const bannerIsInsideModal =
    parentElement?.parentElement?.classList.contains('cmp-container__modal');
  const modalId = bannerIsInsideModal ? simpleBanner?.parentElement?.id : undefined;
  const closeButton: HTMLElement | null = simpleBanner.querySelector(
    '.cmp-simplebanner__closeicon'
  );
  const dismissButton: HTMLElement | null = simpleBanner.querySelector(
    '.cmp-teaser__action-dismiss'
  );
  const ctaButton: HTMLElement | null = simpleBanner.querySelector('.cmp-teaser__action-link');
  const autoClosing = simpleBanner.querySelector('.cmp-simplebanner')?.getAttribute('auto-closing');
  const closingTime =
    autoClosing === 'true'
      ? simpleBanner.querySelector('.cmp-simplebanner')?.getAttribute('closingtime')
      : null;

  if (autoClosing === 'true')
    autoCloseSimpleBanner(simpleBanner, bannerIsInsideModal, modalId, closingTime);

  closeButton?.addEventListener('click', () =>
    closeSimpleBanner(simpleBanner, bannerIsInsideModal, modalId)
  );

  ctaButton?.addEventListener('click', () =>
    closeSimpleBanner(simpleBanner, bannerIsInsideModal, modalId)
  );

  dismissButton?.addEventListener('click', () =>
    closeSimpleBanner(simpleBanner, bannerIsInsideModal, modalId)
  );
});
